import { useFormContext } from 'react-hook-form'

import { Flex, spacing, Stack } from '@cash-design-system/react'
import { FormBlockerElementMerchantTransactionOptionPicker } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { useLogCashWebCdfEvent } from '@cash-web/shared-feature-analytics'
import { WebInteractClick } from '@squareup/customer-data-events-web'

import { MerchantTransactionElement } from '../MerchantTransactionElement/MerchantTransactionElement'

export type MerchantTransactionPickerElementProps = FormBlockerElementMerchantTransactionOptionPicker & {
  formSectionIndex: number
}
export const MerchantTransactionPickerElement = ({
  formSectionIndex,
  options,
}: MerchantTransactionPickerElementProps) => {
  const { setValue, getValues, watch } = useFormContext()
  const fieldName = `${formSectionIndex}.merchant_transaction_picker_result.selected_transactions`
  const logCdfEvent = useLogCashWebCdfEvent()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  const getValue = () => {
    return (getValues()?.[formSectionIndex]?.merchant_transaction_picker_result?.selected_transactions ??
      []) as string[]
  }

  const isSelected = (id?: string) => {
    return id != null && getValue().includes(id)
  }

  watch(fieldName)

  const elements = options?.map((option, index) => {
    const { transactionId: id } = option
    return (
      <MerchantTransactionElement
        key={id}
        index={index + 1}
        selected={isSelected(id)}
        onChange={() => {
          logCdfEvent(
            WebInteractClick({
              componentName: 'MerchantTransactionPickerElement',
              componentType: id,
            })
          )
          const value = getValue()
          const newValue = isSelected(id) ? value.filter(v => v !== id) : [...value, id]
          setValue(fieldName, newValue)
        }}
        {...option}
      />
    )
  })

  if (isArcadeMigrationEnabled) {
    const hasBlockerActions = options?.reduce(
      (prev, curr) => (prev || (curr.actions && curr.actions.length > 0)) ?? false,
      false
    )
    return (
      <Flex flexDirection="column" gap={hasBlockerActions ? 'empty' : 'xl'}>
        {elements}
      </Flex>
    )
  }

  return <Stack space={spacing.m}>{elements}</Stack>
}
